import i18nConfig from "@/config/i18nConfig";
import { TicketOwnerSalutationEnum } from "@/generated/openapi";
import { SelectOption } from "@/models/SelectOption";
import { Validation } from "@vuelidate/core";

const FORM_CONTROL_INVALID_SELECTOR = ".form-error-focusable";

function focusInvalidFormControl(rootElement: HTMLElement) {
  try {
    const errorElement = rootElement.querySelector(FORM_CONTROL_INVALID_SELECTOR);
    (errorElement as HTMLElement).focus();
  } catch(e) {
    console.warn('Unable to focus invalid form control.')
  }
}

function containsInvalidFormControl(rootElement: HTMLElement): boolean {
  return rootElement.querySelectorAll(FORM_CONTROL_INVALID_SELECTOR).length > 0;
}

function validateAndFocusInvalid(v$: Validation, rootElement: HTMLElement): Promise<void> {
  return new Promise(resolve => {
    v$.$validate().then(valid => {
      if (valid) {
        resolve()
      } else {
        focusInvalidFormControl(rootElement)
      }
    })
  })
}

function createSalutationOptions(): SelectOption[] {
  return [
    TicketOwnerSalutationEnum.Mr,
    TicketOwnerSalutationEnum.Ms,
    TicketOwnerSalutationEnum.None
  ].map(salutationType => ({
    value: salutationType,
    label: i18nConfig.global.t('common.owner.salutations.' + salutationType)
  }))
}

export {
  focusInvalidFormControl,
  containsInvalidFormControl,
  validateAndFocusInvalid,
  createSalutationOptions
}
